// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"EY-z","subtitle":"FY-z","wrapper":"GY-z","leftArrow":"HY-z","rightArrow":"IY-z"};